import {
  createStyles,
  withStyles,
  Button,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  OldTileList as TileList,
  useClientOptions
} from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses, DialogProps } from '@paintscout/ui'

import React from 'react'
import type { PresentationOption } from 'paintscout'

import { getPresentationOptions, getObjectLabels } from '@paintscout/util/builder'

import cloneDeep from 'lodash/cloneDeep'

import findIndex from 'lodash/findIndex'

export interface PresentationSelectDialogProps extends Omit<DialogProps, 'message' | 'title' | 'loading'> {
  classes?: DialogProps['classes'] & StyleClasses<typeof styles>
  isTemplate?: boolean
  quoteType?: string
  currentPresentationKey?: string
  onConfirm?: (presentation: PresentationOption) => void
  onCancel?: () => void
}

const styles = (_theme: Theme) =>
  createStyles({
    root: {},
    tileList: {}
  })

function PresentationSelectDialog({
  open,
  classes,
  currentPresentationKey,
  onConfirm,
  onCancel,
  quoteType,
  isTemplate,
  ...props
}: PresentationSelectDialogProps) {
  const { options } = useClientOptions()
  const presentationOptions = getPresentationOptions({ options, quoteType })
  const objectLabels = getObjectLabels({ options })
  const currentIndex = currentPresentationKey ? findIndex(presentationOptions, { key: currentPresentationKey }) : null

  return (
    <Dialog open={open} {...props}>
      <DialogTitle>Select Presentation</DialogTitle>
      {isTemplate && (
        <Alert severity={'info'}>
          The most current version of this Presentation will be used on new {objectLabels.quote.plural.toLowerCase()}{' '}
        </Alert>
      )}
      <DialogContent>
        <div className={classes.root}>
          <TileList
            showUnselected={true}
            items={presentationOptions}
            onChange={onTileClick}
            selectedIndex={currentIndex}
          />
        </div>
      </DialogContent>
      <DialogActions
        leftButton={
          <Button variant="textNoPadding" onClick={onCancel}>
            Cancel
          </Button>
        }
      ></DialogActions>
    </Dialog>
  )

  function onTileClick(event: any, index: number) {
    onConfirm(cloneDeep(presentationOptions[index]))
  }
}

export default withStyles(styles)(PresentationSelectDialog)
